
<template>
  <div class="div-layout">
    <module-title title="设备入库">
      <div class="right">
        <el-button type="primary" size="medium" @click="dialogFormVisible = true">
          单个添加
        </el-button>
        <el-button type="primary" size="medium" @click="dialogUploadVisible = true">
          批量导入
        </el-button>
      </div>
    </module-title>
    <el-form
      ref="searchForm"
      :model="searchForm"
      :inline="true"
      label-position="right"
      label-width="120px"
    >
      <el-form-item label="设备编号：">
        <el-input
          v-model="searchForm.deviceNumber"
          name="deviceNumber"
          placeholder="请输入设备编号"
          class="handle-form-input"
          clearable
        />
      </el-form-item>
      <el-form-item label="SN号：">
        <el-input
          v-model="searchForm.deviceSn"
          name="deviceSn"
          placeholder="请输入SN号"
          class="handle-form-input"
          clearable
        />
      </el-form-item>
      <el-form-item label="项目名称：">
        <el-select
          v-model="searchForm.environmentId"
          name="environmentId"
          size="medium"
          class="handle-form-input"
          clearable
        >
          <el-option label="全部" value="" />
          <el-option
            v-for="item in opList"
            :key="item.environmentId"
            :label="item.projectName"
            :value="item.environmentId"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-search"
          @click="handleSearchFilter"
        >
          查询
        </el-button>
      </el-form-item>
    </el-form>
    <el-table
      v-loading="listLoading"
      :data="dataList"
      highlight-current-row
      fit
      element-loading-text="Loading"
      class="list-table"
    >
      <el-table-column type="index" width="55" align="center" label="序号" />
      <el-table-column label="设备编号" prop="deviceNumber" align="center" />
      <el-table-column label="平板型号" prop="deviceModel" align="center" />
      <el-table-column label="SN号" prop="deviceSn" align="center" />
      <el-table-column label="项目名称" prop="projectName" align="center" />
      <el-table-column label="创建时间" prop="createDate" align="center" />
      <el-table-column label="操作" align="center">
        <template slot-scope="{ row }">
          <el-button
            type="primary"
            size="small"
            @click="del(row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :total="searchForm.total"
      :page.sync="searchForm.pageNum"
      :limit.sync="searchForm.pageSize"
      @pagination="pageCurriculumList"
      @handleSizeChange="handleSizeChange"
    />
    <el-dialog
      v-if="dialogFormVisible"
      title="添加设备"
      width="650px"
      :visible.sync="dialogFormVisible"
      :before-close="resetForm"
    >
      <el-form
        ref="addForm"
        class="add-form"
        :model="addForm"
        :rules="handleRules"
        label-width="100px"
        label-position="right"
      >
        <el-form-item label="设备编号：" prop="deviceNumber">
          <el-input
            v-model="addForm.deviceNumber"
            name="deviceNumber"
            placeholder="请输入设备编号"
            class="handle-form-input"
            clearable
          />
        </el-form-item>
        <el-form-item label="平板型号：" prop="deviceModel">
          <el-input
            v-model="addForm.deviceModel"
            name="deviceModel"
            placeholder="请输入平板型号"
            class="handle-form-input"
            clearable
          />
        </el-form-item>
        <el-form-item label="SN号：" prop="deviceSn">
          <el-input
            v-model="addForm.deviceSn"
            name="deviceSn"
            placeholder="请输入SN号"
            class="handle-form-input"
            clearable
          />
        </el-form-item>
        <el-form-item label="项目名称：" prop="environmentId">
          <el-select
            v-model="addForm.environmentId"
            name="environmentId"
            size="medium"
            class="handle-form-input"
            clearable
          >
            <el-option
              v-for="item in opList"
              :key="item.environmentId"
              :label="item.projectName"
              :value="item.environmentId"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">
          取 消
        </el-button>
        <el-button type="primary" @click="submit">
          确 定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="dialogUploadVisible"
      :close-on-click-modal="false"
      :visible.sync="dialogUploadVisible"
      title="批量导入"
      width="540px"
    >
      <el-form
        ref="uploadSubmitData"
        class="add-form"
        :model="uploadSubmitData"
        :rules="handleRules"
        label-width="100px"
        label-position="right"
      >
        <el-form-item label="项目名称：">
          <el-select
            v-model="uploadSubmitData.environmentId"
            name="environmentId"
            size="medium"
            class="handle-form-input"
            clearable
          >
            <el-option
              v-for="item in opList"
              :key="item.environmentId"
              :label="item.projectName"
              :value="item.environmentId"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div style="display: flex; justify-content: center;">
        <a class="down_btn" href="/static/设备入库下载模板.xlsx"><el-button type="primary" style=" margin-right: 20px" icon="el-icon-upload2" size="medium">下载模板</el-button></a>
        <el-upload
          ref="upload"
          action=""
          :headers="uploadHeader"
          :http-request="onSuccess"
          :multiple="false"
          :limit="1"
          name="file"
          accept=".xls, .xlsx"
          :show-file-list="true"
          :data="uploadSubmitData"
        >
          <el-button
            :loading="fileUploading"
            size="medium"
            type="primary"
            icon="el-icon-upload2"
          >
            {{ fileUploading?'上传文件中...':'上传文件' }}
          </el-button>
        </el-upload>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogUploadVisible = false">
          取 消
        </el-button>
        <el-button type="primary" @click="importSubmit">
          确 定
        </el-button>
      </div>
    </el-dialog>
    <!-- 异常数据 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleImportAbnormal"
      title="导入失败"
      width="540px"
    >
      <p style="padding:0 0 20px 20px;">
        失败原因如下：
      </p>
      <el-scrollbar wrap-class="abnormal-table">
        <el-table
          :data="errorList"
          fit
          highlight-current-row
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="异常原因" prop="errorMsg" align="center">
            <template slot-scope="scope">
              <span class="red">{{ scope.row.errorMsg }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-scrollbar>
    </el-dialog>
  </div>
</template>

<script>
import { getEnvDeviceList, getDeviceRelationsList, getEnvDeviceRelationsDel, getEnvDeviceRelationsAdd, getEnvDeviceRelationsBatch } from '@/api/smartTablet/env.js';
import { getToken } from '@/utils/auth';
export default {
  name: 'SmartTabletDevice',
  data: () => {
    return {
      // 项目列表
      opList: [],
      listLoading: false,
      // 列表数据
      dataList: [],
      // 搜索表单
      searchForm: {
        deviceNumber: null,
        deviceSn: null,
        environmentId: null,
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      uploadUrl: '', // 上传文件URL
      uploadHeader: {
      }, // 上传文件上传头
      addForm: {
        deviceModel: '',
        deviceNumber: '',
        deviceSn: '',
        environmentId: ''
      },
      fileUploading: false,
      // 批量导入状态
      dialogUploadVisible: false,
      // 添加表单状态
      dialogFormVisible: false,
      //  批量导入上传文件参数
      uploadSubmitData: {
        environmentId: ''
      },
      errorList: [],
      dialogVisibleImportAbnormal: false
    };
  },
  computed: {
    handleRules() {
      return {
        deviceModel: [{ required: true, message: '请输入平板型号', trigger: 'blur' }],
        deviceNumber: [{ required: true, message: '请输入设备编号', trigger: 'blur' }],
        deviceSn: [{ required: true, message: '请输入SN号', trigger: 'blur' }],
        environmentId: [{ required: true, message: '请输入所属项目', trigger: 'blur' }]
      };
    }
  },
  mounted() {
    this.initUploadData();
  },
  methods: {
    // 初始化上传数据
    initUploadData() {
      const accessToken = getToken();
      this.uploadHeader = {
        Authorization: `Bearer ${accessToken}`
      };
      // 获取设备入库列表
      this.fetchdataList();
      // 获取项目名称列表
      getEnvDeviceList({ pageNum: 1, pageSize: 99999 }).then(res => {
        this.opList = res.data.list;
      });
    },
    resetForm() {
      this.addForm = {
        deviceModel: '',
        deviceNumber: '',
        deviceSn: '',
        environmentId: ''
      };
      this.dialogFormVisible = false;
    },
    // 单个添加确认
    submit() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          getEnvDeviceRelationsAdd(this.addForm).then(res => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.dialogFormVisible = false;
            this.fetchdataList();
            this.resetForm('addForm');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 查询列表
    fetchdataList() {
      getDeviceRelationsList(this.searchForm).then(res => {
        if (res.data && res.data.list && res.data.list.length) {
          this.dataList = res.data.list;
          this.searchForm.total = res.data.total;
        } else {
          this.dataList = [];
          this.searchForm.total = 0;
        }
        this.listLoading = false;
      }).catch((err) => {
        console.log(err);
        this.listLoading = false;
        this.dataList = [];
        this.searchForm.total = 0;
      });
    },
    // 批量导入确认
    importSubmit() {
      if (!this.uploadSubmitData.environmentId) {
        this.$message({
          message: '请选择所属项目',
          type: 'error'
        });
        return;
      }
      getEnvDeviceRelationsBatch(this.uploadSubmitData.file, this.uploadSubmitData.environmentId).then((response) => {
        if (response.code === '0') {
          this.$message.success('导入成功');
          this.fetchdataList();
          this.dialogUploadVisible = false;
        } else {
          this.dialogVisibleImportAbnormal = true;
          response.data.forEach(v => {
            this.errorList.push({ errorMsg: v });
          });
        }
        this.$refs.upload.clearFiles();
      });
    },
    // 导入上传成功
    onSuccess(params) {
      const file = params.file;
      const formData = new FormData();
      formData.append('file', file);
      this.uploadSubmitData.file = formData;
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchdataList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchdataList();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchdataList();
    },
    // 删除
    del(row) {
      this.$confirm(`是否确认删除该设备？`, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        getEnvDeviceRelationsDel(row.deviceRelationId).then(res => {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.fetchdataList();
        });
      });
    }
  }
};
</script>

